export enum Locale {
  NEW_ZEALAND = <any>'en-NZ',
  SWEDEN = <any>'sv'
}
